import { UseCase } from './UseCase';
export class RefreshCleavageDrawpileQuantityUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.cleavage.retrieveCleavageDrawpileQuantity()
            .then(cleavageDrawpileQuantity => this.applicationServices.interface.updateCleavageDrawpileQuantity(cleavageDrawpileQuantity));
    }
}
